exports = module.exports = require("../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".title-reset-password{\n    margin-top: 10px;\n    margin-bottom: 5px;\n}", ""]);

